import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  /** The `user_role` assignment row's own id — not the Role id or the User id. */
  id: number;
}

/** DELETE `/user/user_role/{user_role_id}/` — removes one user-to-Role assignment. */
export const useDeleteUserRole = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.delete(`${env.verifyServiceUrl}user/user_role/${params.id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
